
  import { defineComponent } from 'vue';
  import { Icon } from '@/ui/components/icon/Icon';

  interface LinkButtonProps {
    text: string;
    icon?: string;
  }

  export default defineComponent<LinkButtonProps>({
    components: { Icon },
    props: ['icon', 'text'],
    emits: ['click'],
  });
